$(document).ready(function () {
	let $ingridients = $('.select-ingredients');
	$ingridients.SumoSelect({
		placeholder: 'Выберите ингредиенты',
		okCancelInMulti: true,
		search: true
	});

	$ingridients.on('change', function () {
		setTimeout(() => {
			$('body').find('#catalog-filter-form').submit();
		}, 200);
	});

	$('.SumoSelect > .optWrapper.multiple > .MultiControls > p.btnOk').click(function () {
		setTimeout(() => {
			$('body').find('#catalog-filter-form').submit();
		}, 200);
	});
});